<script setup lang="ts">
const props = defineProps({
  active: {
    default: false,
    type: Boolean,
  },
  color: {
    default: 'indigo',
    type: String as PropType<SectionFeatureBadgeColor>,
  },
  icon: {
    default: '',
    type: String,
  },
  isChatbox: {
    default: false,
    type: Boolean,
  },
  label: {
    required: true,
    type: String,
  },
  to: {
    default: undefined,
    type: [Object, String] as PropType<RouteLocation | string>,
  },
})

function onClick() {
  if (props.isChatbox) {
    toggleChatbox('open')
  }
}
</script>

<template>
  <div>
    <UButton
      class="gradient-texture-reverse group/badge-card transition-base hover:scale-102 w-full cursor-pointer rounded-xl px-4 py-2 shadow-md hover:shadow-lg md:px-8 md:py-4"
      :class="active ? 'ring-1 ring-indigo-400 dark:ring-indigo-600' : ''"
      :target="typeof to === 'string' ? '_blank' : undefined"
      :to="to"
      @click="onClick"
    >
      <div class="flex items-center gap-2">
        <UIcon
          v-if="icon"
          class="size-4 md:size-6"
          :class="{
            'text-amber-600 dark:text-amber-400': color === 'amber',
            'text-gray-900 dark:text-gray-100': color === 'black',
            'text-blue-600 dark:text-blue-400': color === 'blue',
            'text-cyan-600 dark:text-cyan-400': color === 'cyan',
            'text-emerald-600 dark:text-emerald-400': color === 'emerald',
            'text-gray-600 dark:text-gray-400': color === 'gray',
            'text-indigo-600 dark:text-indigo-400': color === 'indigo',
            'text-orange-600 dark:text-orange-400': color === 'orange',
            'text-purple-600 dark:text-purple-400': color === 'purple',
            'text-red-600 dark:text-red-400': color === 'red',
            'text-yellow-600 dark:text-yellow-400': color === 'yellow',
          }"
          :name="icon"
        />

        <span class="whitespace-nowrap text-xs md:whitespace-normal md:text-sm">{{ label }}</span>

        <div
          v-if="!isChatbox"
          class="flex h-full w-4 items-center justify-center"
        >
          <UIcon
            class="transition-base size-4 -translate-x-6 text-indigo-600 opacity-0 group-focus-within/badge-card:translate-x-0 group-focus-within/badge-card:opacity-100 group-hover/badge-card:translate-x-0 group-hover/badge-card:opacity-100 group-focus/badge-card:translate-x-0 group-focus/badge-card:opacity-100 dark:text-indigo-400"
            :name="getIcon('arrowRight')"
          />
        </div>
      </div>
    </UButton>
  </div>
</template>
